import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum TaxDetailsFormErrorStatesEnum {
    CreateDetailsFailed = ErrorStateScheduleEnum.TaxDetailsFormStatesStartIndex,
    UpdateDetailsFailed
}
